<ng-container *ngIf="isActive()">
  <ng-container *ngTemplateOutlet="content ? content : defaultTabContent"></ng-container>
  <ng-template #defaultTabContent><ng-content></ng-content></ng-template>
</ng-container>
